import axios from 'axios'
import axiosInstance from '../axiosInstance'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import getHeadersformdata from './getHeaderFormdata'
import { HTTP_STATUS } from '../constants/httpstatus/HttpsStatus'
import { HTTP_METHOD } from '../constants/httpMethod/HttpMethod'


//ALL Distributors List Action  
export const getverificationDocumentAction = () => dispatch => {
    const API_URL = localStorage.getItem('countryBackendUrl')
    const url = API_URL + Url.VERIFICATION_DOCUMENT;
    let options = Object.assign({ method: HTTP_METHOD.GET})
    options.headers = getHeaders()
    options.url = url
    return axiosInstance(options).then(response => {
      if (response.status === HTTP_STATUS.SUCCESS) {
          dispatch({ type: types.GET_VERIFICATION_DOCUMENTS, payload: response })
        return response
      } else { return null } })
      .catch(error => {
        errorHandler(error)
    })
  }